var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcAccountWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2227_52405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 25,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 23.75,
    height: 23.75,
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2227_52405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375 15.7246C16.3901 15.7246 17.3971 15.8452 18.3965 16.0859C19.2709 16.2966 20.1409 16.6 21.0068 16.9971L21.3779 17.1729C21.7547 17.3639 22.0517 17.6329 22.2764 17.9854C22.4999 18.3362 22.6093 18.7106 22.6094 19.1191V20.9121H8.14062V19.1191C8.14066 18.7106 8.25006 18.3362 8.47363 17.9854C8.69826 17.6329 8.99525 17.3639 9.37207 17.1729C10.3604 16.6884 11.3541 16.3267 12.3535 16.0859C13.3529 15.8452 14.3599 15.7246 15.375 15.7246ZM15.375 16.2715C14.5171 16.2715 13.666 16.3613 12.8223 16.541L12.4609 16.624C11.5008 16.8585 10.5605 17.2023 9.64062 17.6553L9.63184 17.6602L9.62305 17.6641C9.35255 17.8107 9.12617 18.008 8.95605 18.2578C8.7805 18.5159 8.68754 18.8069 8.6875 19.1191V20.3652H22.0625V19.1191C22.0625 18.8069 21.9695 18.5159 21.7939 18.2578C21.6238 18.008 21.3974 17.8107 21.127 17.6641L21.1182 17.6602L21.1094 17.6553L20.7637 17.4912C20.0699 17.1718 19.3649 16.9133 18.6484 16.7168L18.2891 16.624C17.3272 16.3893 16.3555 16.2715 15.375 16.2715ZM15.375 6.83984C16.2339 6.83984 16.9566 7.14003 17.5703 7.75391C18.1842 8.36763 18.4844 9.09032 18.4844 9.94922C18.4844 10.8081 18.1841 11.5306 17.5703 12.1445C16.9566 12.7582 16.2339 13.0586 15.375 13.0586C14.5161 13.0586 13.7934 12.7582 13.1797 12.1445C12.5659 11.5306 12.2656 10.8081 12.2656 9.94922C12.2656 9.09032 12.5658 8.36763 13.1797 7.75391C13.7934 7.14003 14.5161 6.83984 15.375 6.83984ZM15.375 7.38672C14.6742 7.38672 14.0614 7.64175 13.5645 8.13867C13.0675 8.6356 12.8125 9.24837 12.8125 9.94922C12.8125 10.6501 13.0675 11.2628 13.5645 11.7598C14.0614 12.2567 14.6742 12.5117 15.375 12.5117C16.0758 12.5117 16.6886 12.2567 17.1855 11.7598C17.6825 11.2628 17.9375 10.6501 17.9375 9.94922C17.9375 9.24837 17.6825 8.6356 17.1855 8.13867C16.6886 7.64175 16.0758 7.38672 15.375 7.38672Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcAccountWhiteIcon);
export default __webpack_public_path__ + "static/media/pc_account_white_icon.189b417aa024538b4dc680fe2f74b33f.svg";
export { ForwardRef as ReactComponent };